var map = {
	"./KPRK.svg": 11865,
	"./MC0.svg": 68062,
	"./MC1.svg": 21322,
	"./MC2.svg": 22471,
	"./MC3.svg": 6986,
	"./MC4.svg": 47113,
	"./ZK14.svg": 70289,
	"./ZK25.svg": 86659,
	"./ZK69.svg": 3157,
	"./ZK71.svg": 50026,
	"./ZKCM.svg": 39848,
	"./ZKDE.svg": 66380,
	"./ZKPN.svg": 82254,
	"./ZKRF.svg": 77351,
	"./ZKRG.svg": 75713,
	"./ZKSP.svg": 53421,
	"./ZKVL.svg": 65375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89537;